import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { riskCalculationApi } from '../../services/riskCalculationApi';
import { riskCalculationKeys } from './useGetRiskCalculation';

export function useDeleteRiskCalculation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => riskCalculationApi.deleteRiskCalculation(id),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully deleted risk calculation');
        queryClient.invalidateQueries({ queryKey: riskCalculationKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to delete risk calculation'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to delete risk calculation'}`);
    },
  });
}
